__turbopack_context__.v({
  "actionL": "buttonDropDown-module-scss-module__RDKSZa__actionL",
  "actionM": "buttonDropDown-module-scss-module__RDKSZa__actionM",
  "actionS": "buttonDropDown-module-scss-module__RDKSZa__actionS",
  "chevronIcon": "buttonDropDown-module-scss-module__RDKSZa__chevronIcon",
  "group": "buttonDropDown-module-scss-module__RDKSZa__group",
  "menu": "buttonDropDown-module-scss-module__RDKSZa__menu",
  "trigger": "buttonDropDown-module-scss-module__RDKSZa__trigger",
});
